import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { Screens } from '../constants/usage';
import { SearchResultsPage } from '../search-results/SearchResultsPage';
import { UmbrellaCollectionPage } from './UmbrellaCollectionPage';
import { useCollectionQuery } from '../search-results/hooks/useCollectionQuery';
import { jsx as _jsx } from "react/jsx-runtime";
export function FeaturedCollectionRoute() {
  const collectionResult = useCollectionQuery({
    mode: 'url'
  });
  if (collectionResult.isUmbrellaCollection) {
    return /*#__PURE__*/_jsx(UsageScreenProvider, {
      screen: Screens.UMBRELLA_COLLECTION,
      children: /*#__PURE__*/_jsx(UmbrellaCollectionPage, {})
    });
  }
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    screen: Screens.FEATURED_COLLECTION,
    children: /*#__PURE__*/_jsx(SearchResultsPage, {})
  });
}